export const FORM_ENTRY_FIELD_TYPES = {
    checkbox: 'Checkbox',
    singleLineText: 'Single Line Text',
    paragraphText: 'Paragraph Text',
    multipleChoice: 'Multiple Choice',
    dropDown: 'Drop Down',
    date: 'Date',
};
